/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Service for queuing modals, so there will be only one open modal at a time
 *
 * @module enervee_utils.common
 */

function modalQueueService() {
    var _pub = {};

    // This is overridden by the close callback of the latest opened modal, so it will be closed before another
    // modal opens up
    var lastOpenedModalCloseCallback = null;
    _pub.closePastModals = function(closeCallback) {
        if (lastOpenedModalCloseCallback && typeof lastOpenedModalCloseCallback === "function") {
            lastOpenedModalCloseCallback();
        }
        lastOpenedModalCloseCallback = closeCallback;
    };

    return _pub;
}

module.exports = modalQueueService;